<template>
  <div class="container pt-5">
    <h1 class="text-center ">{{ $t('common.page_not_found') }}</h1>
    <div class="mt-5 d-flex flex-row justify-content-center">
      <button @click="back()" class="btn btn-primary w-25">{{$t('buttons.back')}}</button>
    </div>

  </div>

</template>

<script>
export default {
  name: "NotFoundPage",
  methods:{
    back(){
      this.$router.go(-2)
    }
  }

}
</script>

<style scoped>

</style>
